// // // utilities.js
// // import {
// //   IconReport,
// //   IconCalendarStats,
// //   IconUserPlus,
// //   IconScan,
// //   IconList,
// //   IconBuilding,
// //   IconChecklist,
// //   IconUsers,
// //   IconHistory,
// //   IconCar,
// //   IconUsersGroup,
// //   IconFileText,
// // } from "@tabler/icons-react";

// // const icons = {
// //   IconReport,
// //   IconCalendarStats,
// //   IconUserPlus,
// //   IconScan,
// //   IconList,
// //   IconBuilding,
// //   IconChecklist,
// //   IconUsers,
// //   IconHistory,
// //   IconCar,
// //   IconUsersGroup,
// //   IconFileText,
// // };

// // const UserType = {
// //   Admin: "Admin",
// //   User: "User",
// //   Staff: "Staff",
// //   GateKeeper: "GateKeeper",
// // };
// // // Admin routes
// // const adminUtilities = {
// //   id: "utilities",
// //   title: "Utilities",
// //   type: "group",
// //   children: [
// //     {
// //       id: "department",
// //       title: "Department",
// //       type: "collapse",
// //       icon: icons.IconBuilding,
// //       children: [
// //         {
// //           id: "add-department",
// //           title: "Add Department",
// //           type: "item",
// //           url: "/add-department",
// //           icon: icons.IconUserPlus,
// //         },
// //         {
// //           id: "all-department",
// //           title: "All Department",
// //           type: "item",
// //           url: "/all-department",
// //           icon: icons.IconList,
// //         },
// //       ],
// //     },
// //     {
// //       id: "staff",
// //       title: "Department Head",
// //       type: "collapse",
// //       icon: icons.IconUsers,
// //       children: [
// //         {
// //           id: "add-staff",
// //           title: "Add Department Head",
// //           type: "item",
// //           url: "/add-staff",
// //           icon: icons.IconUserPlus,
// //         },
// //         {
// //           id: "all-staff",
// //           title: "All Department Head",
// //           type: "item",
// //           url: "/all-staff",
// //           icon: icons.IconList,
// //         },
// //       ],
// //     },
// //     {
// //       id: "gatekeeper",
// //       title: "GateKeeper",
// //       type: "collapse",
// //       icon: icons.IconUsers,
// //       children: [
// //         {
// //           id: "add-gatekeeper",
// //           title: "Add GateKeeper",
// //           type: "item",
// //           url: "/add-gatekeeper",
// //           icon: icons.IconUserPlus,
// //         },
// //         {
// //           id: "all-gatekeeper",
// //           title: "All GateKeeper",
// //           type: "item",
// //           url: "/all-gatekeeper",
// //           icon: icons.IconList,
// //         },
// //       ],
// //     },
// //     {
// //       id: "visitor",
// //       title: "Visitor",
// //       type: "collapse",
// //       icon: icons.IconChecklist,
// //       children: [
// //         {
// //           id: "add-visitor",
// //           title: "Add Visitor",
// //           type: "item",
// //           url: "/add-visitor",
// //           icon: icons.IconUserPlus,
// //         },
// //         {
// //           id: "all-visitor",
// //           title: "All Visitor",
// //           type: "item",
// //           url: "/visitor-list",
// //           icon: icons.IconList,
// //         },
// //         {
// //           id: "employee",
// //           title: "Employee",
// //           type: "item",
// //           url: "/employee-visitor",
// //           icon: icons.IconUsersGroup,
// //         },
// //         {
// //           id: "vehicle",
// //           title: "Vehicle",
// //           type: "item",
// //           url: "/vehicle-visitor",
// //           icon: icons.IconCar,
// //         },
// //         {
// //           id: "visitor-history",
// //           title: "Visitor History",
// //           type: "item",
// //           url: "/visitor-history",
// //           icon: icons.IconHistory,
// //         },
// //       ],
// //     },

// //     {
// //       id: "entry-approval-form",
// //       title: "Entry Approval Forms",
// //       type: "collapse",
// //       icon: icons.IconFileText,
// //       children: [
// //         {
// //           id: "all-approval-form",
// //           title: "Entry Approval Form List",
// //           type: "item",
// //           url: "/approval-form",
// //           icon: icons.IconList,
// //         },
// //         {
// //           id: "after-work-entry-exit-history",
// //           title: "After work Entry Exit History",
// //           type: "item",
// //           url: "/after-work-entry-exit-history",
// //           icon: icons.IconHistory,
// //         },
// //       ],
// //     },

// //     {
// //       id: "vehicle-gate-pass",
// //       title: "Vehicle Gate Pass",
// //       type: "collapse",
// //       icon: icons.IconFileText,
// //       children: [
// //         {
// //           id: "all-vehicle-gatepass-list",
// //           title: "Vehicle Gate Pass List",
// //           type: "item",
// //           url: "/vehicle-gatepass",
// //           icon: icons.IconList,
// //         },
// //         {
// //           id: "vehicle-visitor-history",
// //           title: "Vehicle Visitor History",
// //           type: "item",
// //           url: "/vehicle-visitor-history",
// //           icon: icons.IconHistory,
// //         },
// //       ],
// //     },

// //     {
// //       id: "visitor-gate-pass",
// //       title: "Visitor Gate Pass",
// //       type: "collapse",
// //       icon: icons.IconFileText,
// //       children: [
// //         {
// //           id: "all-visitor-gatepass-list",
// //           title: "Visitor Gate Pass List",
// //           type: "item",
// //           url: "/visitor-gatepass",
// //           icon: icons.IconList,
// //         },
// //         {
// //           id: "temp-visitor-history",
// //           title: "Temp Visitor History",
// //           type: "item",
// //           url: "/temp-visitor-history",
// //           icon: icons.IconHistory,
// //         },
// //       ],
// //     },

// //     {
// //       id: "material-entry-exit",
// //       title: "Material Entry Exit Pass",
// //       type: "collapse",
// //       icon: icons.IconFileText,
// //       children: [
// //         {
// //           id: "material-entry-exit",
// //           title: "Material Entry Exit List",
// //           type: "item",
// //           url: "/material-entry-exit",
// //           icon: icons.IconList,
// //         },
// //         {
// //           id: "material-pass-history",
// //           title: "Material History",
// //           type: "item",
// //           url: "/material-pass-history",
// //           icon: icons.IconHistory,
// //         },
// //       ],
// //     },
// //     {
// //       id: "scan-qr-code",
// //       title: "Scan QR Code",
// //       type: "item",
// //       url: "/scan-qr-code",
// //       icon: icons.IconScan,
// //     },
// //   ],
// // };

// // // GateKeeper routes
// // const gatekeeperUtilities = {
// //   id: "utilities",
// //   title: "Utilities",
// //   type: "group",
// //   children: [
// //     {
// //       id: "scan-qr-code",
// //       title: "Scan QR Code",
// //       type: "item",
// //       url: "/scan-qr-code",
// //       icon: icons.IconScan,
// //     },
// //     {
// //       id: "visitor-history",
// //       title: "Visitor History",
// //       type: "item",
// //       url: "/visitor-history",
// //       icon: icons.IconHistory,
// //     },
// //     {
// //       id: "after-work-entry-exit-history",
// //       title: "After work Entry Exit History",
// //       type: "item",
// //       url: "/after-work-entry-exit-history",
// //       icon: icons.IconHistory,
// //     },
// //     {
// //       id: "vehicle-visitor-history",
// //       title: "Vehicle Visitor History",
// //       type: "item",
// //       url: "/vehicle-visitor-history",
// //       icon: icons.IconHistory,
// //     },
// //     {
// //       id: "temp-visitor-history",
// //       title: "Temp Visitor History",
// //       type: "item",
// //       url: "/temp-visitor-history",
// //       icon: icons.IconHistory,
// //     },
// //     {
// //       id: "material-pass-history",
// //       title: "Material History",
// //       type: "item",
// //       url: "/material-pass-history",
// //       icon: icons.IconHistory,
// //     },
// //   ],
// // };

// // const staffUtilities = {
// //   id: "staff-utilities",
// //   title: "Approvals",
// //   type: "group",
// //   children: [
// //     {
// //       id: "temp-visitor-approval",
// //       title: "Temp Visitor Approval",
// //       type: "item",
// //       url: "/all-temp-visitor",
// //       icon: icons.IconUsers,
// //     },
// //     {
// //       id: "vehicle-gatepass-approval",
// //       title: "Vehicle Gate Pass Approval",
// //       type: "item",
// //       url: "/all-vehicle-gatepass",
// //       icon: icons.IconTruck,
// //     },
// //     {
// //       id: "entry-approval",
// //       title: "Entry Approval",
// //       type: "item",
// //       url: "/all-entry-approval",
// //       icon: icons.IconLogin,
// //     },
// //     {
// //       id: "material-permit-approval",
// //       title: "Material Permit Approval",
// //       type: "item",
// //       url: "/all-material-permit",
// //       icon: icons.IconPackage,
// //     },
// //   ],
// // };

// // // ✅ Export a function instead of static object
// // export const getUtilities = () => {
// //   const userType = localStorage.getItem("userType"); // read dynamically
// //   if (userType === UserType.Admin) return adminUtilities;
// //   if (userType === UserType.GateKeeper) return gatekeeperUtilities;
// //   if (userType === UserType.Staff) return staffUtilities;

// //   return { id: "utilities", title: "Utilities", type: "group", children: [] };
// // };

// // utilities.js
// import {
//   IconReport,
//   IconCalendarStats,
//   IconUserPlus,
//   IconScan,
//   IconList,
//   IconBuilding,
//   IconChecklist,
//   IconUsers,
//   IconHistory,
//   IconCar,
//   IconUsersGroup,
//   IconFileText,
//   IconTruck,
//   IconLogin,
//   IconPackage,
// } from "@tabler/icons-react";

// const icons = {
//   IconReport,
//   IconCalendarStats,
//   IconUserPlus,
//   IconScan,
//   IconList,
//   IconBuilding,
//   IconChecklist,
//   IconUsers,
//   IconHistory,
//   IconCar,
//   IconUsersGroup,
//   IconFileText,
//   IconTruck,
//   IconLogin,
//   IconPackage,
// };

// const UserType = {
//   Admin: "Admin",
//   User: "User",
//   Staff: "Staff",
//   GateKeeper: "GateKeeper",
// };

// // 🟦 Department Section
// const departmentSection = {
//   id: "department-section",
//   title: "Department",
//   type: "group",
//   children: [
//     {
//       id: "department",
//       title: "Department",
//       type: "collapse",
//       icon: icons.IconBuilding,
//       children: [
//         {
//           id: "add-department",
//           title: "Add Department",
//           type: "item",
//           url: "/add-department",
//           icon: icons.IconUserPlus,
//         },
//         {
//           id: "all-department",
//           title: "All Department",
//           type: "item",
//           url: "/all-department",
//           icon: icons.IconList,
//         },
//       ],
//     },
//     {
//       id: "staff",
//       title: "Department Head",
//       type: "collapse",
//       icon: icons.IconUsers,
//       children: [
//         {
//           id: "add-staff",
//           title: "Add Department Head",
//           type: "item",
//           url: "/add-staff",
//           icon: icons.IconUserPlus,
//         },
//         {
//           id: "all-staff",
//           title: "All Department Head",
//           type: "item",
//           url: "/all-staff",
//           icon: icons.IconList,
//         },
//       ],
//     },
//   ],
// };

// // 🟦 GateKeeper Section
// const gatekeeperSection = {
//   id: "gatekeeper-section",
//   title: "Gate Keeper",
//   type: "group",
//   children: [
//     {
//       id: "gatekeeper",
//       title: "GateKeeper",
//       type: "collapse",
//       icon: icons.IconUsers,
//       children: [
//         {
//           id: "add-gatekeeper",
//           title: "Add GateKeeper",
//           type: "item",
//           url: "/add-gatekeeper",
//           icon: icons.IconUserPlus,
//         },
//         {
//           id: "all-gatekeeper",
//           title: "All GateKeeper",
//           type: "item",
//           url: "/all-gatekeeper",
//           icon: icons.IconList,
//         },
//       ],
//     },
//   ],
// };

// // 🟦 Scan QR Code Section
// const scanSection = {
//   id: "scan-section",
//   title: "Scan QR Code",
//   type: "group",
//   children: [
//     {
//       id: "scan-qr-code",
//       title: "Scan QR Code",
//       type: "item",
//       url: "/scan-qr-code",
//       icon: icons.IconScan,
//     },
//   ],
// };

// // 🟦 Gate Pass Forms Section
// const gatepassSection = {
//   id: "gatepass-section",
//   title: "Gate Pass Forms",
//   type: "group",
//   children: [
//     {
//       id: "entry-approval-form",
//       title: "Entry Approval Forms",
//       type: "collapse",
//       icon: icons.IconFileText,
//       children: [
//         {
//           id: "all-approval-form",
//           title: "Entry Approval Form List",
//           type: "item",
//           url: "/approval-form",
//           icon: icons.IconList,
//         },
//         {
//           id: "after-work-entry-exit-history",
//           title: "After work Entry Exit History",
//           type: "item",
//           url: "/after-work-entry-exit-history",
//           icon: icons.IconHistory,
//         },
//       ],
//     },
//     {
//       id: "vehicle-gate-pass",
//       title: "Vehicle Gate Pass",
//       type: "collapse",
//       icon: icons.IconFileText,
//       children: [
//         {
//           id: "all-vehicle-gatepass-list",
//           title: "Vehicle Gate Pass List",
//           type: "item",
//           url: "/vehicle-gatepass",
//           icon: icons.IconList,
//         },
//         {
//           id: "vehicle-visitor-history",
//           title: "Vehicle Visitor History",
//           type: "item",
//           url: "/vehicle-visitor-history",
//           icon: icons.IconHistory,
//         },
//       ],
//     },
//     {
//       id: "visitor-gate-pass",
//       title: "Visitor Gate Pass",
//       type: "collapse",
//       icon: icons.IconFileText,
//       children: [
//         {
//           id: "all-visitor-gatepass-list",
//           title: "Visitor Gate Pass List",
//           type: "item",
//           url: "/visitor-gatepass",
//           icon: icons.IconList,
//         },
//         {
//           id: "temp-visitor-history",
//           title: "Temp Visitor History",
//           type: "item",
//           url: "/temp-visitor-history",
//           icon: icons.IconHistory,
//         },
//       ],
//     },
//     {
//       id: "material-entry-exit",
//       title: "Material Entry Exit Pass",
//       type: "collapse",
//       icon: icons.IconFileText,
//       children: [
//         {
//           id: "material-entry-exit",
//           title: "Material Entry Exit List",
//           type: "item",
//           url: "/material-entry-exit",
//           icon: icons.IconList,
//         },
//         {
//           id: "material-pass-history",
//           title: "Material History",
//           type: "item",
//           url: "/material-pass-history",
//           icon: icons.IconHistory,
//         },
//       ],
//     },
//   ],
// };

// // 🟦 Visitor Forms Section
// const visitorSection = {
//   id: "visitor-section",
//   title: "Visitor Forms",
//   type: "group",
//   children: [
//     {
//       id: "visitor",
//       title: "Visitor",
//       type: "collapse",
//       icon: icons.IconChecklist,
//       children: [
//         {
//           id: "add-visitor",
//           title: "Add Visitor",
//           type: "item",
//           url: "/add-visitor",
//           icon: icons.IconUserPlus,
//         },
//         {
//           id: "all-visitor",
//           title: "All Visitor",
//           type: "item",
//           url: "/visitor-list",
//           icon: icons.IconList,
//         },
//         {
//           id: "employee",
//           title: "Employee",
//           type: "item",
//           url: "/employee-visitor",
//           icon: icons.IconUsersGroup,
//         },
//         {
//           id: "vehicle",
//           title: "Vehicle",
//           type: "item",
//           url: "/vehicle-visitor",
//           icon: icons.IconCar,
//         },
//         {
//           id: "visitor-history",
//           title: "Visitor History",
//           type: "item",
//           url: "/visitor-history",
//           icon: icons.IconHistory,
//         },
//       ],
//     },
//   ],
// };

// // 🟩 Combine sections for Admin
// const adminUtilities = [
//   departmentSection,
//   gatekeeperSection,
//   visitorSection,
//   gatepassSection,
//   scanSection,
// ];

// // 🟨 GateKeeper Routes
// const gatekeeperUtilities = {
//   id: "utilities",
//   title: "Utilities",
//   type: "group",
//   children: [
//     {
//       id: "scan-qr-code",
//       title: "Scan QR Code",
//       type: "item",
//       url: "/scan-qr-code",
//       icon: icons.IconScan,
//     },
//     {
//       id: "visitor-history",
//       title: "Visitor History",
//       type: "item",
//       url: "/visitor-history",
//       icon: icons.IconHistory,
//     },
//     {
//       id: "after-work-entry-exit-history",
//       title: "After work Entry Exit History",
//       type: "item",
//       url: "/after-work-entry-exit-history",
//       icon: icons.IconHistory,
//     },
//     {
//       id: "vehicle-visitor-history",
//       title: "Vehicle Visitor History",
//       type: "item",
//       url: "/vehicle-visitor-history",
//       icon: icons.IconHistory,
//     },
//     {
//       id: "temp-visitor-history",
//       title: "Temp Visitor History",
//       type: "item",
//       url: "/temp-visitor-history",
//       icon: icons.IconHistory,
//     },
//     {
//       id: "material-pass-history",
//       title: "Material History",
//       type: "item",
//       url: "/material-pass-history",
//       icon: icons.IconHistory,
//     },
//   ],
// };

// // 🟧 Staff Routes
// const staffUtilities = {
//   id: "staff-utilities",
//   title: "Approvals",
//   type: "group",
//   children: [
//     {
//       id: "temp-visitor-approval",
//       title: "Temp Visitor Approval",
//       type: "item",
//       url: "/all-temp-visitor",
//       icon: icons.IconUsers,
//     },
//     {
//       id: "vehicle-gatepass-approval",
//       title: "Vehicle Gate Pass Approval",
//       type: "item",
//       url: "/all-vehicle-gatepass",
//       icon: icons.IconTruck,
//     },
//     {
//       id: "entry-approval",
//       title: "Entry Approval",
//       type: "item",
//       url: "/all-entry-approval",
//       icon: icons.IconLogin,
//     },
//     {
//       id: "material-permit-approval",
//       title: "Material Permit Approval",
//       type: "item",
//       url: "/all-material-permit",
//       icon: icons.IconPackage,
//     },
//   ],
// };

// // ✅ Export based on userType
// export const getUtilities = () => {
//   const userType = localStorage.getItem("userType");
//   if (userType === UserType.Admin) return adminUtilities;
//   if (userType === UserType.GateKeeper) return [gatekeeperUtilities];
//   if (userType === UserType.Staff) return [staffUtilities];

//   return [];
// };

import {
  IconReport,
  IconCalendarStats,
  IconUserPlus,
  IconScan,
  IconList,
  IconBuilding,
  IconChecklist,
  IconUsers,
  IconHistory,
  IconCar,
  IconUsersGroup,
  IconFileText,
  IconTruck,
  IconLogin,
  IconPackage,
} from "@tabler/icons-react";
// import { useTranslation } from "react-i18next";

const icons = {
  IconReport,
  IconCalendarStats,
  IconUserPlus,
  IconScan,
  IconList,
  IconBuilding,
  IconChecklist,
  IconUsers,
  IconHistory,
  IconCar,
  IconUsersGroup,
  IconFileText,
  IconTruck,
  IconLogin,
  IconPackage,
};

const UserType = {
  Admin: "Admin",
  User: "User",
  Staff: "Staff",
  GateKeeper: "GateKeeper",
  Subadmin: "SubAdmin"
};

export const getUtilities = (t) => {
  const userType = localStorage.getItem("userType");

  // 🟦 Department Section
  const departmentSection = {
    id: "department-section",
    title: t("sidebar.Department"),
    type: "group",
    children: [
      {
        id: "department",
        title: t("sidebar.Department"),
        type: "collapse",
        icon: icons.IconBuilding,
        children: [
          {
            id: "add-department",
            title: t("sidebar.Add_Department"),
            type: "item",
            url: "/add-department",
            icon: icons.IconUserPlus,
          },
          {
            id: "all-department",
            title: t("sidebar.All_Department"),
            type: "item",
            url: "/all-department",
            icon: icons.IconList,
          },
        ],
      },
      {
        id: "staff",
        title: t("sidebar.Department_Head"),
        type: "collapse",
        icon: icons.IconUsers,
        children: [
          {
            id: "add-staff",
            title: t("sidebar.Add_Department_Head"),
            type: "item",
            url: "/add-staff",
            icon: icons.IconUserPlus,
          },
          {
            id: "all-staff",
            title: t("sidebar.All_Department_Head"),
            type: "item",
            url: "/all-staff",
            icon: icons.IconList,
          },
        ],
      },
    ],
  };

  // 🟦 GateKeeper Section
  const gatekeeperSection = {
    id: "gatekeeper-section",
    title: t("sidebar.Gate_Keeper"),
    type: "group",
    children: [
      {
        id: "gatekeeper",
        title: t("sidebar.GateKeeper"),
        type: "collapse",
        icon: icons.IconUsers,
        children: [
          {
            id: "add-gatekeeper",
            title: t("sidebar.Add_GateKeeper"),
            type: "item",
            url: "/add-gatekeeper",
            icon: icons.IconUserPlus,
          },
          {
            id: "all-gatekeeper",
            title: t("sidebar.All_GateKeeper"),
            type: "item",
            url: "/all-gatekeeper",
            icon: icons.IconList,
          },
        ],
      },
    ],
  };

  // 🟦 Scan QR Code Section
  const scanSection = {
    id: "scan-section",
    title: t("sidebar.Scan_QR_Code"),
    type: "group",
    children: [
      {
        id: "scan-qr-code",
        title: t("sidebar.Scan_QR_Code"),
        type: "item",
        url: "/scan-qr-code",
        icon: icons.IconScan,
      },
    ],
  };

  // 🟦 Gate Pass Forms Section
  const gatepassSection = {
    id: "gatepass-section",
    title: t("sidebar.Gate_Pass_Forms"),
    type: "group",
    children: [
      {
        id: "visitor-gate-pass",
        title: t("sidebar.Visitor_Gate_Pass"),
        type: "collapse",
        icon: icons.IconFileText,
        children: [
          {
            id: "all-visitor-gatepass-list",
            title: t("sidebar.Visitor_Gate_Pass_List"),
            type: "item",
            url: "/visitor-gatepass",
            icon: icons.IconList,
          },
          {
            id: "temp-visitor-history",
            title: t("sidebar.Temp_Visitor_History"),
            type: "item",
            url: "/temp-visitor-history",
            icon: icons.IconHistory,
          },
        ],
      },
      {
        id: "vehicle-gate-pass",
        title: t("sidebar.Vehicle_Gate_Pass"),
        type: "collapse",
        icon: icons.IconFileText,
        children: [
          {
            id: "all-vehicle-gatepass-list",
            title: t("sidebar.Vehicle_Gate_Pass_List"),
            type: "item",
            url: "/vehicle-gatepass",
            icon: icons.IconList,
          },
          {
            id: "vehicle-visitor-history",
            title: t("sidebar.Vehicle_Visitor_History"),
            type: "item",
            url: "/vehicle-visitor-history",
            icon: icons.IconHistory,
          },
        ],
      },

      {
        id: "material-entry-exit",
        title: t("sidebar.Material_Entry_Exit_Pass"),
        type: "collapse",
        icon: icons.IconFileText,
        children: [
          {
            id: "material-entry-exit",
            title: t("sidebar.Material_Entry_Exit_List"),
            type: "item",
            url: "/material-entry-exit",
            icon: icons.IconList,
          },
          {
            id: "material-pass-history",
            title: t("sidebar.Material_History"),
            type: "item",
            url: "/material-pass-history",
            icon: icons.IconHistory,
          },
        ],
      },
      {
        id: "entry-approval-form",
        title: t("sidebar.Entry_Approval_Forms"),
        type: "collapse",
        icon: icons.IconFileText,
        children: [
          {
            id: "all-approval-form",
            title: t("sidebar.Entry_Approval_Form_List"),
            type: "item",
            url: "/approval-form",
            icon: icons.IconList,
          },
          {
            id: "after-work-entry-exit-history",
            title: t("sidebar.After_work_Entry_Exit_History"),
            type: "item",
            url: "/after-work-entry-exit-history",
            icon: icons.IconHistory,
          },
        ],
      },
    ],
  };

  const subadminManagement = {
    id: "subadmin-management",
    title: t("sidebar.Subadmin_Management"),
    type: "group",
    icon: icons.IconUsersGroup,
    children: [
      {
        id: "subadmin",
        title: t("sidebar.subadmin"),
        type: "collapse",
        icon: icons.IconUsers,
        children: [
          {
            id: "add-subadmin",
            title: t("sidebar.Add_Subadmin"),
            type: "item",
            url: "/add-subadmin",
            icon: icons.IconUserPlus,
          },
          {
            id: "view-subadmin",
            title: t("sidebar.View_Subadmin"),
            type: "item",
            url: "/view-subadmin",
            icon: icons.IconList,
          },
        ],
      }
    ]
  };

  // 🟩 Combine sections for Admin
  const adminUtilities = [
    subadminManagement,
    departmentSection,
    gatekeeperSection,
    // visitorSection,
    gatepassSection,
    scanSection,
  ];

  const subadminSection = [
    // id: "subadmin-section",
    // title: t("sidebar.Subadmin"),
    // type: "group",
    // children: [
      // You can reuse Admin sections but exclude Add/View Subadmin
      departmentSection,
      gatekeeperSection,
      gatepassSection,
      scanSection,
    ]
  // };

  // 🟨 GateKeeper Routes
  const gatekeeperUtilities = {
    id: "utilities",
    title: t("sidebar.Utilities"),
    type: "group",
    children: [
      {
        id: "scan-qr-code",
        title: t("sidebar.Scan_QR_Code"),
        type: "item",
        url: "/scan-qr-code",
        icon: icons.IconScan,
      },
      {
        id: "visitor-history",
        title: t("sidebar.Visitor_History"),
        type: "item",
        url: "/visitor-history",
        icon: icons.IconHistory,
      },
      {
        id: "after-work-entry-exit-history",
        title: t("sidebar.After_work_Entry_Exit_History"),
        type: "item",
        url: "/after-work-entry-exit-history",
        icon: icons.IconHistory,
      },
      {
        id: "vehicle-visitor-history",
        title: t("sidebar.Vehicle_Visitor_History"),
        type: "item",
        url: "/vehicle-visitor-history",
        icon: icons.IconHistory,
      },
      {
        id: "temp-visitor-history",
        title: t("sidebar.Temp_Visitor_History"),
        type: "item",
        url: "/temp-visitor-history",
        icon: icons.IconHistory,
      },
      {
        id: "material-pass-history",
        title: t("sidebar.Material_History"),
        type: "item",
        url: "/material-pass-history",
        icon: icons.IconHistory,
      },
    ],
  };

  // 🟧 Staff Routes
  const staffUtilities = {
    id: "staff-utilities",
    title: t("sidebar.Approvals"),
    type: "group",
    children: [
      {
        id: "temp-visitor-approval",
        title: t("sidebar.Temp_Visitor_Approval"),
        type: "item",
        url: "/all-temp-visitor",
        icon: icons.IconUsers,
      },
      {
        id: "vehicle-gatepass-approval",
        title: t("sidebar.Vehicle_Gate_Pass_Approval"),
        type: "item",
        url: "/all-vehicle-gatepass",
        icon: icons.IconTruck,
      },
      {
        id: "entry-approval",
        title: t("sidebar.Entry_Approval"),
        type: "item",
        url: "/all-entry-approval",
        icon: icons.IconLogin,
      },
      {
        id: "material-permit-approval",
        title: t("sidebar.Material_Permit_Approval"),
        type: "item",
        url: "/all-material-permit",
        icon: icons.IconPackage,
      },
    ],
  };


  if (userType === UserType.Admin) return adminUtilities;
  if (userType === UserType.Subadmin) return subadminSection;
  if (userType === UserType.GateKeeper) return [gatekeeperUtilities];
  if (userType === UserType.Staff) return [staffUtilities];

  return [];
};
